<template>
	<v-tabs slider-color="#282828" class="app-tabs tabs_comp" v-model="localValue" background-color="transparent" dark v-on="$listeners">
		<v-tab v-for="item in tabItems" :key="item.tab" :ripple="false" tabindex="-1">
			<SIcon class="mr-2" v-if="item.tabIcon" :name="item.tabIcon" :width="item.tabIconWidth" :height="item.tabIconHeight" />
			{{ item.title }}
		</v-tab>
	</v-tabs>
</template>

<script>
import VModelMixin from '@/mixins/VModelMixin';
export default {
	name: 'AppTabSelector',
	mixins: [VModelMixin],
	props: { tabItems: { type: Array } },
};
</script>

<style scoped lang="scss">
.app-tabs {
	$tabs-height: 34px;

	max-height: $tabs-height;
	border-bottom: 1px solid #dfdfe2;
	::v-deep {
		&.v-tabs {
			max-height: $tabs-height;
		}
		.v-tabs-bar {
			height: $tabs-height;
		}
	}
}
</style>
